import { useLocation } from "react-router-dom";
import { Link } from "@/i18n/LangRouting";
import { Gift } from "lucide-react";
import { useExhibition } from "@/visitor/ExhibitionShell";
import { giftsOf, giftName, discountOf } from "@/lib/gifts";

export default function NudgeBanner() {
  const { slug, hasGift, visitor, exhibition, t, lang } = useExhibition();
  const location = useLocation();
  const gifts = giftsOf(exhibition);
  if (hasGift || (!gifts.enabled && visitor)) return null;
  const gift = giftName(exhibition, lang, t);
  return (
    <Link to={`/e/${slug}/signup?next=${encodeURIComponent(location.pathname)}`} data-testid="nudge-banner"
      className="flex items-center gap-3 px-5 py-2.5 bg-[var(--accent)] text-white text-sm hover:brightness-110 transition-[filter]">
      <Gift size={16} className="flex-none" />
      <span className="flex-1 leading-tight">{gifts.enabled ? t("nudge_banner", { gift, discount: discountOf(exhibition) }) : t("nudge_banner_nogift")}</span>
      <span className="text-[0.65rem] font-bold tracking-[0.15em] uppercase whitespace-nowrap">{t(gifts.enabled ? "nudge_cta" : "nudge_cta_nogift")} →</span>
    </Link>
  );
}
